import { useDispatch } from "react-redux";
import useFetch from "./hooks/useFetch";
import CreateRoutes from "./routes";
import { getSiteSettingList } from "./services/siteSettingService";
import { getSettings } from "./redux/slice/settingsSlice";
import { useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { BannerProvider } from "./providers/BannerProviders";
import { useContext, useEffect } from "react";
import { verifyAuth } from "./redux/slice/authSlice";
import { useSelector } from "react-redux";
import SocketContext, { useSocket } from "./providers/SocketContext";
import { setCount } from "./redux/slice/messageSlice";
import { getPermissions, setPermission } from "./redux/slice/permissionSlice";
import LoadingFallback from "./components/elements/LoadingFallback";

function App() {
  const dispatch = useDispatch();
  const { loading: permissionLoading } = useSelector(
    (state) => state?.permission
  );

  const location = useLocation();
  const { session } = useSelector((state) => state?.authProvider);
  const { socket } = useContext(SocketContext);

  useFetch({
    dependencies: ["siteSetting"],
    fetchFunction: async () => {
      const res = await getSiteSettingList();
      dispatch(getSettings(res?.data));
      return res?.data;
    },
  });

  useEffect(() => {
    dispatch(verifyAuth());
  }, [location.pathname, session?.status]);

  useEffect(() => {
    if (socket?.connected && session?.user?._id) {
      socket.emit("totalUnreadCount");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [socket?.connected, session?.user?._id]);

  useSocket(
    "totalUnreadCountResponse",
    (res) => {
      dispatch(setCount(res?.totalUnseen));
    },
    []
  );

  useSocket(
    "sendMessageResponse",
    async (res) => {
      if (res?.status !== 200 || !res?.data) return;
      socket.emit("totalUnreadCount");
    },
    [session?.user?._id]
  );

  useSocket(
    "permissionResponse",
    async ({ res, userId }) => {
      if (res?.status !== 200) return;
      if (session?.user?._id === userId) {
        dispatch(setPermission(res?.data?.permission || []));
      }
    },
    [session?.user?._id]
  );

  useEffect(() => {
    dispatch(getPermissions({ authId: session?.user?._id }));
  }, [session?.user?._id]);

  return (
    <>
      {permissionLoading ? (
        <LoadingFallback />
      ) : (
        <HelmetProvider>
          <BannerProvider>
            <CreateRoutes />
          </BannerProvider>
        </HelmetProvider>
      )}
    </>
  );
}

export default App;
